import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledSeparator = styled.div`
  width: 1rem;
  height: 3rem;
  border-right: 1px solid ${getColor('silverSand')};
  margin-left: 1rem;
  margin-right: 2rem;
`;

export const StyledForecastHeader = styled.div`
  display: flex;
  align-items: center;
`;
